import {useContext} from "react";
import {ContentContext} from "../../ContentContext";
import {CustomQuote} from "../common/index";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";

function Info() {
    const data = useContext(ContentContext);

    if (!data?.showSections.includes("info")) {
        return null;
    }

    return (
        <section className={"info"}>
            <CustomQuote icon={<InfoOutlineIcon />}>
                <span dangerouslySetInnerHTML={{__html: data?.infoText}} />
            </CustomQuote>
        </section>
    );
}

export default Info;
